module.exports = __webpack_public_path__ + "static/media/irregularTriangle2.c38b4ff0.svg";